import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../api/admin";

const useClocksWithCollectionCount = (
  collectionId: string,
  betaOnly: boolean,
) => {
  return useQuery<{ count: number }>({
    queryKey: ["clocksWithCollectionCount", collectionId, betaOnly],
    queryFn: () =>
      adminApiClient.getClocksWithCollectionCount(collectionId, betaOnly),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: !!collectionId,
  });
};

export default useClocksWithCollectionCount;
